import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const LoginButton = () => {
    const { loginWithRedirect, isAuthenticated, logout } = useAuth0();

    if (isAuthenticated) {
        return (
            <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>logout</button>
        );
        
    }
          
    return <button className="btn btn-primary 
            mx-5 my-5 px-4"
        onClick={() => loginWithRedirect()}>
        Acceso</button>;
};

